<template>
  <v-layout row>
    <v-flex md2 class="pa-0">
      <sub-side-bar :items="settingsMenu" />
    </v-flex>
    <v-flex md10>
      <router-view />
    </v-flex>
  </v-layout>
</template>

<script>
import subSideBar from '../../common/subSideBar'
export default {
  name: 'campaings-main',
  components: {
    subSideBar
  },
  data() {
    return {}
  },
  computed: {
    settingsMenu() {
      return {
        title: 'Campaign Manager',
        menu: [
          {
            title: 'General',
            items: [
              {
                title: 'Overview',
                link: `/campaigns/overview`
              },
              {
                title: 'Campaigns',
                link: `/campaigns/all`
              },
              {
                title: 'Template Messages',
                link: `/campaigns/template-messages`
              },
              {
                title: 'WhatsApp Apps',
                link: `/campaigns/whatsapp-apps`
              }
            ]
          },
          // {
          //   title: 'Settings',
          //   items: [
          //     {
          //       title: 'Template Messages Settings',
          //       link: `/campaigns/templates-cogs`
          //     },
          //     {
          //       title: 'Whatsapp Apps',
          //       link: `/campaigns/whatsapp`
          //     }
          //   ]
          // }
        ]
      }
    }
  }
}
</script>

<style lang="css" scoped>
.campaings-app-main-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
}
</style>
